export default __webpack_public_path__ + "static/media/degradado600.53287466.png";